import { AppState } from '@news-mono/web-common'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {
    StyledPlayIcon,
    StyledPodcastBodyContainer,
    StyledPodcastButton,
    StyledPodcastDescription,
    StyledPodcastHeader,
    StyledPodcastImage,
    StyledPodcastInfo,
    StyledPodcastSegment,
    StyledPodcastSharing,
    StyledPodcastShowMore,
    StyledPodcastSubHeading,
    StyledPodcastTitle,
} from './PodcastIntroTile.styled'

export interface PodcastIntroTileProps {
    podcast: PodcastType
    title: string
    description: string
    releaseDay?: string
    shareUrl: string
    onEvent: (event: any) => void
}

export type PodcastType = 'court-in-the-act' | 'behind-the-white-line'

export const PodcastIntroTile: React.FC<PodcastIntroTileProps> = (props) => {
    const renditionType = useSelector(
        (state: AppState) => state.render.renditionType,
    )

    const [showMore, setShowMore] = useState(false)

    const tileImage = () => {
        switch (props.podcast) {
            case 'court-in-the-act':
                return require('./assets/court-in-the-act-tile.jpg')
            case 'behind-the-white-line':
                return require('./assets/behind-the-white-line-tile.jpg')
            default:
                return ''
        }
    }

    const tileColor = () => {
        switch (props.podcast) {
            case 'court-in-the-act':
                return 'linear-gradient(180deg, #111A4D 64.01%, #0A0C20 100.05%)'
            case 'behind-the-white-line':
                return 'linear-gradient(180deg, #2e2e2e 64.01%, #161616 100.05%)'
            default:
                return ''
        }
    }

    return (
        <>
            {renditionType !== 'app' && (
                <StyledPodcastSegment color={tileColor()}>
                    <StyledPodcastImage
                        src={tileImage()}
                        width={'180px'}
                        height={'180px'}
                        alt={`Logo for ${props.title} podcast`}
                    />
                    <StyledPodcastInfo>
                        <StyledPodcastHeader>
                            <StyledPodcastTitle>
                                {props.title}
                            </StyledPodcastTitle>
                            <StyledPodcastSharing
                                url={props.shareUrl}
                                text={`Check out the latest episode for ${props.title}`}
                                onEvent={props.onEvent}
                                shareOptions={[
                                    'facebook',
                                    'twitter',
                                    'email',
                                    'clipboard',
                                ]}
                            />
                        </StyledPodcastHeader>
                        <StyledPodcastBodyContainer>
                            <StyledPodcastSubHeading>
                                {props.releaseDay}
                            </StyledPodcastSubHeading>
                            <StyledPodcastDescription showMore={showMore}>
                                {props.description}
                            </StyledPodcastDescription>
                            <StyledPodcastShowMore
                                onClick={() => {
                                    setShowMore(!showMore)
                                }}
                            >
                                {showMore ? 'Show less ...' : 'Show more ...'}
                            </StyledPodcastShowMore>
                        </StyledPodcastBodyContainer>
                        <StyledPodcastButton href={props.shareUrl + '#anchor'}>
                            <StyledPlayIcon />
                            <div>listen</div>
                        </StyledPodcastButton>
                    </StyledPodcastInfo>
                </StyledPodcastSegment>
            )}
        </>
    )
}
